import {
    bexHttpClient
} from '../../clients';
import {
    CreateVectorIndexRequest,
    DeleteSubOrganizationRequest,
    CreateSubOrganizationVectorIndexResponse,
    DeleteSubOrganizationVectorIndexResponse,
} from '../bexService.types';
import {
    AxiosResponse
} from 'axios';
/**
 * Service class for performing organization index operations.
 */
class OrganizationIndex {

    /**
     * Creates a new vector index (Instruction).
     * @param {CreateVectorIndexRequest} data - The data for the new vector index.
     * @returns {Promise<CreateSubOrganizationVectorIndexResponse>} The response containing the vector index.
     */
    async createSubOrganizationVectorIndex(data: CreateVectorIndexRequest): Promise<CreateSubOrganizationVectorIndexResponse> {
        const response = await bexHttpClient.post('/db/sub-organizations/create-sub-organization-vector-index', data);
        return response;
    }

    /**
     * Deletes an existing vector index
     * @param {DeleteSubOrganizationRequest} data - The deleted data for the vector index.
     * @returns {Promise<DeleteSubOrganizationVectorIndexResponse>} The response containing the vector index.
     */
    async deleteSubOrganizationVectorIndex(data: DeleteSubOrganizationRequest): Promise<DeleteSubOrganizationVectorIndexResponse> {
        const response = await bexHttpClient.delete('/db/sub-organizations/delete-sub-organization-vector-index', {
            data
        });
        return response;
    }

    /**
     * Lists organization vector indexes
     * @param {string} organizationId - The ID of the organization.
     * @returns {Promise<AxiosResponse<any>>} The response containing the vector index.
     * Note: Using 'any' because the list vector indexes response structure is not defined in the types file
     */
    async listOrganizationVectorIndex(organizationId: string): Promise<AxiosResponse<any>> {
        const response = await bexHttpClient.get(`/db/organizations/list-sub-organization-vector-index/${organizationId}`);
        return response;
    }

}

const organizationIndex = new OrganizationIndex();
export { organizationIndex };